import { render, staticRenderFns } from "./FeatureMove.vue?vue&type=template&id=3aaca40a&scoped=true&lang=pug&"
import script from "./FeatureMove.vue?vue&type=script&lang=js&"
export * from "./FeatureMove.vue?vue&type=script&lang=js&"
import style0 from "./FeatureMove.vue?vue&type=style&index=0&id=3aaca40a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaca40a",
  null
  
)

export default component.exports